export default __webpack_public_path__ + "static/media/scroll-to-top.98888486.png";